import { OmrHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PutThirdPartyInvoiceByThirdPartyClubRegistrationIdData = (orgUnitId, thirdPartyClubRegistrationId, createCartItem, thirdPartyInvoiceArray, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const thirdPartyClubRegistrationIdForUrl = thirdPartyClubRegistrationId ? encodeURIComponent(thirdPartyClubRegistrationId) : 'NaN';
    const url = `/MemberRegistration/OrgUnit/${orgUnitIdForUrl}/TeamInvoice/ThirdPartyClubRegistration/${thirdPartyClubRegistrationIdForUrl}?createCartItem=${createCartItem}`;
    OmrHttpHelper(url, 'PUT', thirdPartyInvoiceArray)
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isArrayLoading: false,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isArrayLoading: false,
          message: message
        });
      });
  }
};

export default PutThirdPartyInvoiceByThirdPartyClubRegistrationIdData;